var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPppointed2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 14,
    stroke: "hsl(0, 0%, 100%)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24.5 28",
    transform: "matrix(-0.1736481776669303,0.984807753012208,-0.984807753012208,-0.1736481776669303,880.3823722716553,88.53616986188888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.5 153.1998291015625Q450.5 259.1998291015625 400 398.6998291015625Q19.5 672.1998291015625 645.5 644.1998291015625 ",
    markerEnd: "url(#SvgjsMarker3846)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    markerWidth: 8,
    markerHeight: 8,
    refX: 4,
    refY: 4,
    viewBox: "0 0 8 8",
    orient: "auto",
    id: "SvgjsMarker3846"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,8 2.6666666666666665,4 0,0 8,4",
    fill: "hsl(0, 0%, 100%)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPppointed2);
export default __webpack_public_path__ + "static/media/pppointed2.042de76062b1515a1f6683a02521f900.svg";
export { ForwardRef as ReactComponent };